<template>
	<div class="frimTag">
		<!--弹出框-->
		<el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="400px" :before-close="handleClose">
			<div class="dialogMain">
				<dl>
					<dt><span class="checktip">*</span>供应商名称：</dt>
					<dd class="cf">
						<el-input v-model="dialogData.name" class="inputWidth" placeholder="供应商名称"></el-input>
					</dd>
				</dl>
				<dl>
					<dt><span class="checktip">*</span>负责人：&emsp;&emsp;</dt>
					<dd class="cf">
						<el-input v-model="dialogData.leader" class="inputWidth" placeholder="负责人"></el-input>
					</dd>
				</dl>
				<dl>
					<dt><span class="checktip">*</span>负责人电话：</dt>
					<dd class="cf">
						<el-input v-model="dialogData.phone" class="inputWidth" placeholder="负责人电话"></el-input>
					</dd>
				</dl>
				<dl>
					<dt><span class="checktip">*</span>地址：&emsp;&emsp;&emsp;</dt>
					<dd class="cf">
						<el-input v-model="dialogData.address" class="inputWidth" placeholder="地址"></el-input>
					</dd>
				</dl>
			</div>
			<span slot="footer" class="dialog-footer">
		    <el-button @click="dialogVisible = false">取 消</el-button>
		    <el-button type="primary" @click="handleConfirm" :loading="loading">确 定</el-button>
		  </span>
		</el-dialog>
		<!--弹出框结束-->
		<!--导航条-->
		<navZcy v-bind:num="'3-1'" style="min-width: 1110px;"></navZcy>
		<div class="line"></div>
		<div class="main">
			<!--页面标题-->
			<div class="top cf">
				<div class="topL fl"><span>供应商</span></div>
				<div class="topR fr">
					<el-button type="success" plain @click="refresh"><i class="el-icon-refresh"></i>刷新</el-button>
				</div>
			</div>
			<div class="line"></div>
			<div class="line"></div>
			<div class="dataTag">
				<!--操作按钮-->
				<div class="handle">
					<div class="fl">
						<img src="../assets/img/dataIcon.png" style="vertical-align: middle;" />
						<span class="" style="display: inline-block; vertical-align: middle;">数据列表</span>
					</div>
					<div class="handleBtn fr">
						<el-button type="primary" size="small" @click="handleAdd">添加</el-button>
						<el-button type="danger" size="small" @click="handleDelete(0,0)">批量删除</el-button>
					</div>
				</div>
				<!--内容列表-->
				<div class="tableData" style="text-align: center;">
					<el-table 
						ref="multipleTable"
						:data="tableData" 
						border 
						@selection-change="handleSelectionChange" 
						style="width: 100%;border-bottom: 1px solid #ddd;">
						<el-table-column type="selection" width="50px">
						</el-table-column>
						<el-table-column type="index" label="序号" width="100px">
						</el-table-column>
						<el-table-column prop="name" label="供应商" width="150px">
						</el-table-column>
						<el-table-column prop="leader" label="负责人" width="86px">
						</el-table-column>
						<el-table-column prop="phone" label="负责人电话" width="107px">
						</el-table-column>
						<el-table-column prop="address" label="地址" width="300px">
						</el-table-column>
						<el-table-column prop="createTime" label="创建时间" width="151px">
							<template slot-scope="scope">
								{{dataTimeFn(scope.row.createTime)}}
							</template>
						</el-table-column>
						<el-table-column label="操作">
							<template slot-scope="scope">
								<a href="javascript:void(0)" @click="handleEdit(scope.$index, scope.row)" style="color: #1ABC9C;">编辑</a>
								<a href="javascript:void(0)" @click="handleDelete(scope.$index, scope.row)" style="color: #1ABC9C;">删除</a>
							</template>
						</el-table-column>
					</el-table>
				</div>				
				<!--分页-->
				<div class="page">
					<el-pagination 
						background 
						:current-page="tableDataArr.currentPage" 
						:page-sizes="[10,20,30,40]" 
						:page-size="tableDataArr.pageSize" 
						layout="total, sizes, prev, pager, next, jumper" 
						:total="tableDataArr.totalSize"
				     	@current-change="handleCurrentChange" 
				     	@size-change="handleSizeChange">						
					</el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import '../assets/css/style.css'
import navZcy from './nav'
export default {
	data() {
		return {
			loading: false,
			dialogTitle: "",      //弹出框标题
			dialogVisible: false, //是否关闭弹出框
			dialogData: {},		  //弹出框参数	
			tableDataArr: {		  //分页参数
				currentPage: 1,
				pageSize: 10,
				totalSize: 0
			},
			tableData: [],		  //列表内容数组			
			multipleSelection: [] //列表复选框选中值
		}
	},
	methods: {
		//页面刷新
		refresh() {
			location.reload()
		},
		getAllCompanyTag() {
			let data = {
				name: '',
				currentPage: this.tableDataArr.currentPage,
				pageSize: this.tableDataArr.pageSize
			}
			let url = "/lightApi/supplier/inquirySupplier/"+sessionStorage.getItem('sessionId')
			this.$store.dispatch('handlePost',{'url': url, 'data': data,'Fn': this.getAllCompanyTagFn,'vue':this})
		},
		//获取企业类型
		getAllCompanyTagFn(data) {
			if(data.msg=="ok"){
				this.tableDataArr = data.data
				this.tableData = this.tableDataArr.items
			}else{
				this.tableData = []
				this.tableDataArr.totalSize = 0
			}
		},
		//弹出框关闭
		handleClose: function(done) {
			done();
		},
		//添加企业标签
		handleAdd: function() {
			this.loading = false
			this.dialogTitle = "添加供应商";
			this.dialogData={
				name: '',
				address: '',
				phone: '',
				leader: '',
			};
			this.dialogVisible = true;
			setTimeout(function(){
				$('.input').focus()
			},100)			
		},
		//编辑企业标签
		handleEdit: function(index, row) {
			this.loading = false
			this.dialogTitle = "编辑供应商";
			this.dialogData = {
				id: row.id,
				name: row.name,
				address: row.address,
				phone: row.phone,
				leader: row.leader
			};
			this.dialogVisible = true;
			setTimeout(function(){
				$('.input').focus()
			},100)	
		},
		//确定添加/编辑
		handleConfirmFn: function(data){
			if(data.msg=="ok"){
				this.dialogVisible = false
				this.getAllCompanyTag()
			}else{	
				this.loading = false			
				this.$message({
					type: 'error',
					message: data.msg
				});				
			}
		},
		handleConfirm: function() {
			this.loading = true
			if(this.dialogData.name&&this.verifyPhone(this.dialogData.phone)){
				let url = ""
				let data = this.dialogData
				if(this.dialogTitle == "添加供应商"){
					url = "/lightApi/supplier/createSupplier/"+sessionStorage.getItem('sessionId')
				}else{
					url = "/lightApi/supplier/updateSupplier/"+sessionStorage.getItem('sessionId')
				}
				this.$store.dispatch('handlePost',{'url': url, 'data': data,'Fn': this.handleConfirmFn,'vue':this})
			}else{
				this.loading = false
				if(this.dialogData.name){
					this.$message({
						type: 'error',
						message: '请输入供应商名称'
					});
				}
				if(this.verifyPhone(this.dialogData.phone)){
					this.$message({
						type: 'error',
						message: '电话格式不对！'
					});
				}				
			}
		},
		//手机号码正则表达式
		verifyPhone: function(val){
			let regexp1 = /^((0\d{2,3})-)(\d{7,8})(-(\d{3,}))?$/.test(val)
			let regexp2 = /^(13[0-9]|14[5|7]|15[0|1|2|3|5|6|7|8|9]|17[0|1|6|7|8]|18[0-9])\d{8}$/.test(val)
			if(regexp1||regexp2){
				return true
			}else{
				return false
			}
		},
		//列表复选框被选中
		handleSelectionChange: function(val){
			this.multipleSelection=[]
			for (let i=0; i<val.length; i++) {
				this.multipleSelection.push(val[i].id)
			}
		},
		//删除企业标签
		handleDeleteFn: function(data) {
			if(data.msg=="ok"){	
				this.getAllCompanyTag()
				this.$message({
					type: 'success',
					message: '删除成功!'
				});
			}else{
				this.$message({
					type: 'error',
					message: data.msg
				});	
			}
		},
		handleDelete: function(index, row) {
			let id = []
			if(row!=0){
				id[0] = row.id
			}else{
				id = this.multipleSelection					
			}
			if(id.length>0){
				this.$confirm('此操作将永久删除该企业标签, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let url = "/lightApi/supplier/deleteSupplier/"+sessionStorage.getItem('sessionId')+"/"+id 
					this.$store.dispatch('handleGet',{'url': url,'Fn': this.handleDeleteFn,'vue':this})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			}else{
				this.$message({
					type: 'info',
					message: '请选择删除项'
				});
			}
		},
        //点击页数
		handleCurrentChange(cur) {
			this.tableDataArr.currentPage = cur
			this.getBrandTag()
		},
		//改变列表显示条目
		handleSizeChange(size) {
			this.tableDataArr.pageSize = size
			this.getBrandTag()
		},
		//时间格式化
		dataTimeFn: function(time){
	   		var oDate
	   		if(time!=""){
				if(typeof(time)=='string'&&time.indexOf(' +0800 CST')!=-1){
					time = time.split(' +0800 CST')[0]
				}
	   			oDate = new Date(time)	
	   		}else{
	   			oDate = new Date()
	   		}
	   					
	  		var mon = oDate.getMonth()+1
	  		var d = oDate.getDate()
	  		if(mon<10){
	  			mon="0"+mon
	  		}
	  		if(d<10){
	  			d="0"+d
	  		}
	  		return oDate.getFullYear()+"-"+mon+"-"+d
	   	}
	},
	mounted() {
		this.getAllCompanyTag()
	},
	components: {
		navZcy
	}
}
</script>

<style scoped>
	.dialogMain dl dt{
		line-height: 40px;
	}
	.inputWidth{
		width: 230px;
	}
</style>


// WEBPACK FOOTER //
// src/components/frimTag.vue